import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import ResizePDFImageListScreen from "./ResizePDFImageListScreen";
import { BASE_URL } from "../Config";

function ResizePDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Resize PDF files" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/resize_pdf", title: "Change PDF Dimensions" },
    data2: { link: "/resize_pdf", title: "PDF Resizer" },
    data3: { link: "/resize_pdf", title: "Change PDF Resolution" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Resize PDF pages online easily. Change page size, scale PDFs, and adjust dimensions quickly with our fast, secure PDF resize tool."
      ></meta>
      <meta
        name="keywords"
        content="resize pdf, resize pdf online, change pdf size, pdf page resize, pdf resizer tool, adjust pdf size, scale pdf pages, pdf page size changer, resize pdf pages online, pdf editor online, pdf management tool, resize pdf for print, resize pdf for upload, pdf layout editor, pdf page scaler, compress pdf, scale pdf pages, pdf compressor, resuce pdf size,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <ResizePDFImageListScreen title={title}></ResizePDFImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our PDF resizer website offers a fast, secure, and reliable way to resize PDF files offline while also supporting resize PDF online functionality when internet access is available. Designed for users who value privacy and performance, this powerful PDF resizer allows you to adjust PDF file size, page dimensions, and layout directly on your device, ensuring complete data security. Whether you need to resize PDFs for online forms, reduce PDF file size for email sharing, or optimize documents for printing, our tool delivers accurate results without compromising quality. Unlike traditional tools that rely only on cloud processing, this platform works offline, making it ideal for professionals, students, and businesses in low-connectivity environments. Using advanced resizing technology, you can easily scale pages, adjust margins, and resize PDF dimensions while maintaining text clarity and image resolution. No unnecessary file uploads are required—your documents remain private and secure at all times. Compatible with desktop and mobile devices, this PDF resizer website helps you resize PDF online or offline, save storage space, and meet strict size and dimension requirements efficiently. If you’re searching for the best PDF resizer offline, resize PDF online, resize PDF without internet, or a secure PDF resizing tool, our platform provides a seamless, user-friendly solution built for speed, accuracy, and privacy." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Resize",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Resize PDF"
            why_use={[
              {
                title: "Meet File Size and Dimension Requirements",
                description:
                  "Many online portals, job applications, government forms, and academic websites have strict limits on PDF file size and page dimensions. Using a compress and resize PDF tool helps you reduce PDF size and adjust page dimensions to meet upload requirements easily.",
              },
              {
                title: "Faster Upload and Download Speed",
                description:
                  "Large PDF files take longer to upload and download. When you compress PDF files and resize PDFs, it significantly improves file transfer speed and ensures a smooth user experience.",
              },
              {
                title: "Easy Sharing via Email and Messaging Apps",
                description:
                  "Email services and messaging platforms often restrict attachment sizes. By using a PDF compressor and resizer, you can share documents quickly without attachment errors or failed uploads.",
              },

              {
                title: "Optimize PDFs for Online Forms",
                description:
                  "Many online forms require PDFs to be under specific size limits such as 200KB. A compress resize PDF online tool helps you optimize documents for fast and successful form submissions.",
              },
              {
                title: "Save Device Storage Space",
                description:
                  "Compressed and resized PDFs occupy less storage on your device. A reliable PDF size reducer helps keep your storage organized and prevents unnecessary memory usage.",
              },
              {
                title: "Improve Website Performance and SEO",
                description:
                  "Smaller PDF files load faster on websites, improving page speed and user engagement. Using compressed and resized PDFs enhances website performance and supports better SEO rankings.",
              },
              {
                title: "Maintain Document Quality",
                description:
                  "Advanced PDF compression and resizing tools preserve text clarity, formatting, and image quality while reducing file size, ensuring professional-looking documents.",
              },
              {
                title: "Better Compatibility Across Devices",
                description:
                  "Different platforms and devices require optimized file sizes and layouts. When you resize PDF pages and compress PDF online, documents display correctly on mobile, tablet, and desktop screens.",
              },
              {
                title: "Enhance Privacy and Security",
                description:
                  "Many modern tools allow you to compress and resize PDF offline or securely online, ensuring sensitive documents remain private and protected during processing.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1609168763}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default ResizePDFMain;
